import React from 'react';
import AcceptanceRate from './acceptanceRate';
import ApplicationFactors from './applicationFactors';
import ApplicationRequirements from './applicationRequirements';
import Deadlines from './deadlines';
import Fees from './fees';
import ImportantPolicies from './importantPolicies';
import RecommendedCourses from './recommendedCourses';

import withCollegeService from '../withCollegeService';
import './styles.css';

export const AcceptanceRateComponent = withCollegeService(
  AcceptanceRate,
  'admissions.acceptanceRate',
  {},
  {
    applicationsAccepted: 'field_he_applications_accepted',
    applicationsReceived: 'field_he_applications_received',
  },
);

export const ApplicationFactorsComponent = withCollegeService(ApplicationFactors, 'admissions.applicationFactors',
  [],
  {
    importance: 'he_importance',
  },
  null,
  null,
  {
    type: 'he_undergraduate_admissions_us',
    field: 'field_he_admission_factor_data',
    fields: {
      field_he_importance: [{ value: '' }],
      field_he_admissionfactortype: [{ value: '' }],
    },
  });

export const ApplicationRequirementsFreshman = withCollegeService(ApplicationRequirements, 'admissions.applicationRequirements',
  [],
  {
    value: 'he_requiredoptrecommend',
  },
  null,
  null,
  {
    type: 'he_undergraduate_admissions_us',
    field: 'field_he_qualification_data_us',
    fields: {
      field_he_qualification_grouping: [{ value: '' }],
    },
  });
export const ApplicationRequirementsTransfer = withCollegeService(ApplicationRequirements, 'admissions.applicationRequirements',
  [],
  {
    value: 'he_requiredoptrecommend',
  },
  null,
  null,
  {
    type: 'he_undergraduate_admissions_us',
    field: 'field_he_qualification_data_us',
    fields: {
      field_he_qualification_grouping: [{ value: '1' }],
    },
  });
export const ApplicationRequirementsInternational = withCollegeService(ApplicationRequirements, 'admissions.applicationRequirements',
  [],
  {
    value: 'he_requiredoptrecommend',
  },
  null,
  null,
  {
    type: 'he_internationaladmissions_us',
    field: 'field_he_qualification_data_us',
    fields: {
      field_he_qualification_grouping: [{ value: '3' }],
    },
  });

export const ApplicationRequirementsComponent = () => (
  <React.Fragment>
    <div styleName="application-requirements-name">Freshman</div>
    <ApplicationRequirementsFreshman entityGroup="freshman" />
    <div styleName="application-requirements-name">Transfer</div>
    <ApplicationRequirementsTransfer entityGroup="transfer" />
    <div styleName="application-requirements-name">International</div>
    <ApplicationRequirementsInternational entityGroup="international" />
  </React.Fragment>
);

export const DeadlinesComponent = withCollegeService(Deadlines, 'admissions.deadlines',
  [],
  {
    month: 'he_month_of_the_deadline',
    day: 'he_day_of_the_deadline',
  },
  null,
  {
    type: 'he_deadline_us',
    fields: {
      field_he_month_of_the_deadline: [{ value: '0' }],
      field_he_day_of_the_deadline: [{ value: '0' }],
    },
  });

export const FeesComponent = withCollegeService(
  Fees,
  'admissions.fees',
  {},
  {
    applicationFee: 'field_he_applicationfee',
    deposit: 'field_he_deposit',
    transferDepositFee: 'field_he_transferappdeposit',
    transferApplicationFee: 'field_he_transferapplicationfee',
    internationalApplicationFee: 'field_he_applicationfee',
    internationalDepositFee: 'field_he_deposit',
  },
);

export const ImportantPoliciesComponent = withCollegeService(ImportantPolicies, 'admissions.importantPolicies', {}, {
  admissionsPolicy: 'field_he_admissionspolicy_id',
  notificationPolicy: 'field_he_notificationpolicy_id',
  registrationPolicy: 'field_he_registrationpolicy_id',
  earlyDecision: 'field_he_earlydecision',
  waitingList: 'field_he_waitinglistused',
});

export const RecommendedCoursesComponent = withCollegeService(RecommendedCourses, 'admissions.recommendedCourses',
  [],
  {
    recomendationYears: 'he_yearsrecommended',
    requiredYears: 'he_yearsrequired',
  },
  null,
  null,
  {
    type: 'he_undergraduate_admissions_us',
    field: 'field_he_highschoolprerequisites',
    fields: {
      field_he_yearsrecommended: [{ value: '0' }],
      field_he_yearsrequired: [{ value: '0' }],
    },
  });
